/**
 * PM List service
 * @module services/pm-list
 */
import { Map } from 'immutable'

/**
 * Get PM List processing state
 * @param {Object} options The options
 * @param {Map} options.pmList The PM List state
 * @param {String} options.listId The list ID
 * @returns {Boolean} True if processing
 */
export function getPmListProcessing (options = {}) {
  const { pmList = Map(), listId } = options
  if (!listId || !Map.isMap(pmList)) {
    return false
  }
  return pmList.getIn([listId, 'processing'], false)
}

/**
 * Get PM List error created date
 * @param {Object} options The options
 * @param {Map} options.pmList The PM List state
 * @param {String} options.listId The list ID
 * @returns {Date|undefined} The error created date
 */
export function getPmListErrorCreated (options = {}) {
  const { pmList = Map(), listId } = options
  if (!listId || !Map.isMap(pmList)) {
    return undefined
  }
  return pmList.getIn([listId, 'errorCreated'])
}

/**
 * Get PM List data created date
 * @param {Object} options The options
 * @param {Map} options.pmList The PM List state
 * @param {String} options.listId The list ID
 * @returns {Date|undefined} The data created date
 */
export function getPmListDataCreated (options = {}) {
  const { pmList = Map(), listId } = options
  if (!listId || !Map.isMap(pmList)) {
    return undefined
  }
  return pmList.getIn([listId, 'dataCreated'])
}

/**
 * Get PM List data
 * @param {Object} options The options
 * @param {Map} options.pmList The PM List state
 * @param {String} options.listId The list ID
 * @returns {Map} The PM List data
 */
export function getPmListData (options = {}) {
  const { pmList = Map(), listId } = options
  if (!listId || !Map.isMap(pmList)) {
    return Map()
  }
  return pmList.getIn([listId, 'data'], Map())
}

/**
 * The time to wait on error before getting a list again
 */
export const GET_PM_LIST_ERROR_CACHE_TIME = (300 * 1000)
